"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientPath = void 0;
var meta_1 = require("./meta");
var message_type_1 = require("../bridge/message-type");
var ClientPath = /** @class */ (function () {
    function ClientPath() {
    }
    /**
     * Will set the client path on the customer website
     */
    ClientPath.updateClientPath = function () {
        // We don't want to update the client path on iframes with no canonical link (widgets)
        if (!meta_1.Meta.hasCanonical) {
            return;
        }
        parent.postMessage({
            type: this.clientPathType.messageType,
            path: this.fromPathAndSearch(window.location.pathname, window.location.search),
        }, meta_1.Meta.host);
    };
    /**
     * Returns the path for the location on the currentTarget of a click event
     * @param event
     */
    ClientPath.fromClickEvent = function (event) {
        return this.fromPathAndSearch(event.currentTarget.pathname, event.currentTarget.search);
    };
    /**
     * Returns the path for the right path type from a pathname and search string
     * @param pathname (eg. "/mallweb/v1/1/c/6/kupon-et-billede")
     * @param search (eg. "?page=2")
     */
    ClientPath.fromPathAndSearch = function (pathname, search) {
        var pathType = this.clientPathType;
        var extractedPath = this.extractedPath(pathname);
        return pathType.pathFromPathAndSearch(extractedPath, search);
    };
    /**
     * Will extract the relevant part of a pathname
     * "/mallweb/v1/1/c/6/kupon-et-billede" will return: "kupon-et-billede/6"
     * @param pathname
     */
    ClientPath.extractedPath = function (pathname) {
        return pathname.split('/').slice(4).join('/');
    };
    Object.defineProperty(ClientPath, "clientPathType", {
        get: function () {
            return meta_1.Meta.useHash ? new Hash() : new GetParameter();
        },
        enumerable: false,
        configurable: true
    });
    return ClientPath;
}());
exports.ClientPath = ClientPath;
var GetParameter = /** @class */ (function () {
    function GetParameter() {
    }
    Object.defineProperty(GetParameter.prototype, "messageType", {
        get: function () {
            return message_type_1.MessageType.GetParam;
        },
        enumerable: false,
        configurable: true
    });
    GetParameter.prototype.pathFromPathAndSearch = function (pathname, search) {
        return '?mw=' + pathname.replace(new RegExp('/', 'g'), '_') + search.replace('?', '&');
    };
    return GetParameter;
}());
var Hash = /** @class */ (function () {
    function Hash() {
    }
    Object.defineProperty(Hash.prototype, "messageType", {
        get: function () {
            return message_type_1.MessageType.Hash;
        },
        enumerable: false,
        configurable: true
    });
    Hash.prototype.pathFromPathAndSearch = function (pathname, search) {
        return '#' + pathname + search;
    };
    return Hash;
}());
